// extracted by mini-css-extract-plugin
module.exports = {"priceWrapper":"DeA_dJLJ","priceSkeleton":"ob7Rl3Ao"};